// extracted by mini-css-extract-plugin
export default {"busca":"Search_busca__Xq+Xs","input":"Search_input__klILD"};